import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const productSchema = z.object({
  volume: z
    .number({
      message: i18nMessage("shared:forms.quotation.volumeRequired"),
      coerce: true,
    })
    .min(0, i18nMessage("shared:forms.quotation.volumeRequired")),
  bottleQuantity: z
    .number({ message: i18nMessage("shared:forms.quotation.quantityRequired"), coerce: true })
    .min(1, i18nMessage("shared:forms.quotation.quantityRequired")),
  value: z
    .number({ message: i18nMessage("shared:forms.quotation.priceRequired"), coerce: true })
    .min(0, i18nMessage("shared:forms.quotation.priceRequired")),
  isNew: z.boolean().optional(),
});

export const woodboxSchema = z.object({
  bottleVolume: z
    .number({
      message: i18nMessage("shared:forms.quotation.volumeRequired"),
      coerce: true,
    })
    .min(0, i18nMessage("shared:forms.quotation.volumeRequired")),
  bottleQuantity: z
    .number({
      message: i18nMessage("shared:forms.quotation.bottleQuantityRequired"),
      coerce: true,
    })
    .min(1, i18nMessage("shared:forms.quotation.bottleQuantityRequired")),
  boxQuantity: z
    .number({
      message: i18nMessage("shared:forms.quotation.boxQuantityRequired"),
      coerce: true,
    })
    .min(1, i18nMessage("shared:forms.quotation.boxQuantityRequired")),
});

export const CotationSchema = z.object({
  country: z.string().min(1, i18nMessage("shared:forms.quotation.countryRequired")),
  products: z.array(productSchema).min(1, i18nMessage("shared:forms.quotation.productsRequired")),
  insurance: z.boolean(),
  express: z.boolean(),
  dapOption: z.boolean(),
  otherFeesToggle: z.boolean(),
  otherFees: z
    .number()
    .min(0, { message: i18nMessage("shared:forms.quotation.otherFeesMin") })
    .optional(),
  customer: z
    .object({
      lastName: z.string().optional(),
      firstName: z.string().optional(),
      companyName: z.string().optional(),
    })
    .refine(
      (data) => {
        const hasName =
          data.firstName &&
          data.firstName.trim() !== "" &&
          data.lastName &&
          data.lastName.trim() !== "";
        const hasCompany = data.companyName && data.companyName.trim() !== "";
        return hasName || hasCompany;
      },
      {
        message: i18nMessage("shared:forms.quotation.customerRequired"),
      },
    ),
  deliveryDateRadio: z.enum(["earliestDelivery", "customDelivery"]),
  customDeliveryDate: z.coerce.date().optional(),
  woodBoxesActivated: z.boolean(),
  woodBoxes: z.array(woodboxSchema),
});

export type CotationFormData = z.infer<typeof CotationSchema>;
